export default __webpack_public_path__ + "static/media/solucao-02.34c2f8ed.webp";